module.exports = __webpack_public_path__ + "static/media/thread-throphy.8419984d.gif";